import { FC, useMemo } from 'react';
import { Wrapper, DeleteButton } from './styles';
import { ProjectAddButton } from 'shared/pages/projectEdit/ProjectAddButton';
import { useTranslation } from 'react-i18next';
import { BLanguageSelectionComponent } from 'core/components/BLanguageSelectionComponent';
import { SaveUserLang } from '../__ADDONS__/__LANG__/Utils/GetUserLang';
import { setAppLang } from '../__ADDONS__/__LANG__/Slice';
import { BilingualismItem } from 'shared/pages/projectEdit/styles';
import { FlexBox } from '@brg/ui';

type IProps = {
    isBilingual: boolean;
    isCompetitionEdit?: boolean;
    isProjectEditPage?: boolean;
    isBookEdit?: boolean;
    text?: string;
    onClick: () => void;
}

export const BilingualSwitcher: FC<IProps> = ({ isBilingual, text, onClick, isCompetitionEdit, isProjectEditPage, isBookEdit }) => {
    const { t, i18n } = useTranslation();

    const AddButton = useMemo(() => {
        if (!isBilingual) {
            return <ProjectAddButton text={text || t('bilingual_switcher.add')} isBookEdit={isBookEdit} isProjectEdit={isProjectEditPage} isCompetitionEdit={isCompetitionEdit} hideIcon={isCompetitionEdit || isProjectEditPage} onClick={onClick} reverse />
        }

        return <DeleteButton className='remove-lang-button' isCompetitionEdit={isCompetitionEdit} onClick={onClick}>{text || t('bilingual_switcher.delete')}</DeleteButton>
    }, [isBilingual, onClick, t, isCompetitionEdit])

    const LangSwitcher = useMemo(() => {
        if (!isBilingual) return null;

        return (
            <BLanguageSelectionComponent
                onLangSelect={(lang) => {
                // @ts-ignore
                SaveUserLang(lang);
                setAppLang(lang);
                i18n.changeLanguage(lang);
                }}
                key={'lang'}
                isProjectPage
                isCompetitionEdit={isCompetitionEdit}
            />
        )
    }, [i18n, isBilingual])

    return (
        <Wrapper>
            {AddButton}
            {isBilingual && i18n.language === 'en' && <FlexBox direction='column' offsetTop={16}>
                <BilingualismItem>— AI does the translation</BilingualismItem>
                <BilingualismItem>— You can edit the AI translation</BilingualismItem>
                <BilingualismItem>— ​​Edited translation is considered author's translation</BilingualismItem>
                <BilingualismItem>— AI translation is updated automatically</BilingualismItem>
            </FlexBox>}
            {LangSwitcher}
           
        </Wrapper>
    )
}import { FC, useMemo } from 'react';
import { Wrapper, DeleteButton } from './styles';
import { ProjectAddButton } from 'shared/pages/projectEdit/ProjectAddButton';
import { useTranslation } from 'react-i18next';
import { BLanguageSelectionComponent } from 'core/components/BLanguageSelectionComponent';
import { SaveUserLang } from '../__ADDONS__/__LANG__/Utils/GetUserLang';
import { setAppLang } from '../__ADDONS__/__LANG__/Slice';
import { BilingualismItem } from 'shared/pages/projectEdit/styles';
import { FlexBox } from '@brg/ui';

type IProps = {
    isBilingual: boolean;
    isCompetitionEdit?: boolean;
    isProjectEditPage?: boolean;
    isBookEdit?: boolean;
    text?: string;
    onClick: () => void;
}

export const BilingualSwitcher: FC<IProps> = ({ isBilingual, text, onClick, isCompetitionEdit, isProjectEditPage, isBookEdit }) => {
    const { t, i18n } = useTranslation();

    const AddButton = useMemo(() => {
        if (!isBilingual) {
            return <ProjectAddButton text={text || t('bilingual_switcher.add')} isBookEdit={isBookEdit} isProjectEdit={isProjectEditPage} isCompetitionEdit={isCompetitionEdit} hideIcon={isCompetitionEdit || isProjectEditPage} onClick={onClick} reverse />
        }

        return <DeleteButton className='remove-lang-button' isCompetitionEdit={isCompetitionEdit} onClick={onClick}>{text || t('bilingual_switcher.delete')}</DeleteButton>
    }, [isBilingual, onClick, t, isCompetitionEdit])

    const LangSwitcher = useMemo(() => {
        if (!isBilingual) return null;

        return (
            <BLanguageSelectionComponent
                onLangSelect={(lang) => {
                // @ts-ignore
                SaveUserLang(lang);
                setAppLang(lang);
                i18n.changeLanguage(lang);
                }}
                key={'lang'}
                isProjectPage
                isCompetitionEdit={isCompetitionEdit}
            />
        )
    }, [i18n, isBilingual])

    return (
        <Wrapper>
            {AddButton}
            {isBilingual && i18n.language === 'en' && <FlexBox direction='column' offsetTop={16}>
                <BilingualismItem>— AI does the translation</BilingualismItem>
                <BilingualismItem>— You can edit the AI translation</BilingualismItem>
                <BilingualismItem>— ​​Edited translation is considered author's translation</BilingualismItem>
                <BilingualismItem>— AI translation is updated automatically</BilingualismItem>
            </FlexBox>}
            {LangSwitcher}
           
        </Wrapper>
    )
}